var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ncnp-callback"},[_c('div',{staticClass:"callback-panel"},[_c('i',{class:_vm.iconClass}),_c('p',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }